import { get } from '@/api/settings';
import * as allTypes from '../mutation-type';
import * as types from './tableUserParam-mutation-type';

function initialState() {
  return {
    tableUserParam: {},
  };
}
const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_TABLE_USER_PARAM](state, tableUserParam) {
    state.tableUserParam = tableUserParam;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};
const actions = {
  async loadTableUserParam({ commit }) {
    const responseString = (await get(types.TABLE_USER_PARAM_KEY)).data.result;
    const response = JSON.parse(responseString);
    commit(types.SET_TABLE_USER_PARAM, response);
  },
};

const getters = {
  tableUserParam: state => {
    return state.tableUserParam;
  },
  paramForTab: (state) => (ref) => {
    if (!ref || !state.tableUserParam[ref]) {
      return null;
    }
    return state.tableUserParam[ref];
  },
};
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
